import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'rc-slider';
import { Question } from './Question';
import 'rc-slider/assets/index.css';


export class SliderQuestion extends React.Component {
  constructor() {
    super();
    this.state = {
      currentValue: null,
    };

    this.onSliderChange = this.onSliderChange.bind(this);
  }

  onSliderChange = (value) => {
    this.setState({ currentValue: value });
    const questionnaireItemId = this.props.questionnaireItem.questionnaireItemId;
    this.props.updateAnswer(questionnaireItemId, value);
    if (this.props.questionnaireItem.isValid === false) {
      this.props.validateQuestionnaire();
    }
  }

  getParameters = () => {
    const rangeLength = this.props.questionnaireItem.upperBound - this.props.questionnaireItem.lowerBound;
    const numberOfLabels = rangeLength > 10 ? 10 : rangeLength;
    const stepSize = Math.floor(rangeLength / numberOfLabels);
    return {
      rangeLength,
      numberOfLabels,
      stepSize,
    };
  }

  getMarks = () => {
    const result = {};
    const p = this.getParameters();
    const min = this.props.questionnaireItem.lowerBound;
    const max = this.props.questionnaireItem.upperBound;
    let i = 0;
    for (i = min; i <= max; i += p.stepSize) {
      result[i] = i;
    }
    if (i > max) {
      i = max;
      result[i] = i;
    }
    return result;
  }

  render() {
    const { questionnaireItem } = this.props;
    const opts = {};
    if (this.props.answerItem) {
      opts.value = this.props.answerItem.numberAnswer;
    }
    return (
      <div data-qa-item="slider_question_type" className="question-area">
        <Question questionNumber={questionnaireItem.questionNumber}
          isValid={ questionnaireItem.isValid }
          formattedText={questionnaireItem.formattedText}
          isRequired={questionnaireItem.isRequired}
        />
        <Slider dots min={questionnaireItem.lowerBound} marks={this.getMarks()} step={this.getParameters().stepSize}
          max={questionnaireItem.upperBound} disabled={this.props.disabled}
          value={this.state.currentValue} onChange={this.onSliderChange}
          {...opts}
        />
        <div className="slider-labels">
          <span className="lower-label understated">{questionnaireItem.lowerBoundLabel}</span>
          <span className="upper-label understated">{questionnaireItem.upperBoundLabel}</span>
        </div>
      </div>
    );
  }
}

SliderQuestion.propTypes = {
  questionnaireItem: PropTypes.object,
  updateAnswer: PropTypes.func,
  validateQuestionnaire: PropTypes.func,
  disabled: PropTypes.bool,
  answerItem: PropTypes.object,
};
